var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.772 10.462-8.5-8.25c-.216-.21-.539-.269-.814-.153-.277.118-.458.39-.458.691v4.252c-7.743.134-14 6.474-14 14.248 0 .342.241.622.572.708.059.015.118.022.177.022.274 0 .541-.157.678-.404 2.245-4.056 6.519-6.576 11.155-6.576h1.418v4.25c0 .301.181.573.458.691.274.116.599.057.814-.153l8.5-8.25c.146-.141.228-.335.228-.538s-.082-.397-.228-.538z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconForward);
export default __webpack_public_path__ + "static/media/icon-forward.dd4300fa9649580081a1e373d1b41005.svg";
export { ForwardRef as ReactComponent };